/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetOpenComplianceCases = require('../services/GetOpenComplianceCases');
var GetAllCompliancePaymentDue = require('../services/GetAllCompliancePaymentDue');

var NonDepInternalComplianceView = require('../views/NonDepInternalComplianceView');

module.exports = function() {
  NProgress.start();
  NProgress.set(0.6);

  $.when(GetOpenComplianceCases(), GetAllCompliancePaymentDue()).done(function(complianceCases, paymentDue) {
    NavUtils.navigate('nondep/compliance/dashboard');
    Scaffold.content.show(
      new NonDepInternalComplianceView({
        model: new Backbone.Model({ complianceCases: complianceCases, paymentDue: paymentDue })
      })
    );
    NProgress.done();
  });
};
